import Popup from 'presentation/components/popup/index.jsx';
import Dialog from 'presentation/components/dialog/index.jsx';
import FlexPane from 'presentation/components/flex-pane/index.jsx';
import ScrollPane from 'presentation/components/scroll-pane/index.jsx';

const QuickNavigationPane = props => {
    const {
        isEnabled,
        onOutsideClick,
        children,
        mojitoTools: { config },
    } = props;

    return config.showDialog ? (
        <Dialog
            config={config.dialog}
            isOpen={isEnabled}
            onClickOutside={onOutsideClick}
            onCloseButtonClick={onOutsideClick}
            key={'quickNavigationPaneDialog'}
            class={'ta-QuickNavigationDialog'}
        >
            {children}
        </Dialog>
    ) : (
        <Popup
            visible={isEnabled}
            config={config.popup}
            captureOutsideClicks={true}
            class={'ta-QuickNavigationPopup'}
            onOutsideClick={onOutsideClick}
        >
            <ScrollPane config={config.scrollPane}>
                <FlexPane config={config.quickNavigationContainer}>{children}</FlexPane>
            </ScrollPane>
        </Popup>
    );
};

export default QuickNavigationPane;
